var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M66.43,34.29l13,13H48.52v4.5H79.39l-13,13,3.18,3.18L88,49.5,69.61,31.11ZM56.5,81h-36V18h36V29.25H61V18a4.51,4.51,0,0,0-4.5-4.5h-36A4.51,4.51,0,0,0,16,18V81a4.51,4.51,0,0,0,4.5,4.5h36A4.51,4.51,0,0,0,61,81V69.75H56.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.cbb2155efe4b11ca7fc3c4d20faeffbc.svg";
export { ForwardRef as ReactComponent };